export const formatDate = (date: string): string => {
    if (!date) return '-'

    const d = typeof date === 'string' ? new Date(date) : date
    return d.toLocaleString('id-ID', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
}
export const formatDateOnly = (date: string): string => {
    if (!date) return '-'

    const d = typeof date === 'string' ? new Date(date) : date
    return d.toLocaleString('id-ID', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });
}

